import { RETURN_TYPE_ROUTE_FOR_INDIVIDUAL_RECORD, ReturnType } from "./return";

/**
 * Nav area every return-like record lives under, mirroring the merchant app's
 * `MerchantRoutesContext.returnsBaseUrl`. Without it the link only resolves for
 * the types that still have a legacy top-level redirect shim.
 */
const RETURNS_AREA = "returns";

/**
 * In-app path to a single return/claim/warranty/recycle record, relative to the
 * merchant app's `MerchantRoutesContext.returnsBaseUrl`. Each type lives under a
 * different section, so a claim linked as a return 404s.
 */
export function getReturnHref(
  returnsBaseUrl: string,
  return_: { _id: string; type: ReturnType },
): string {
  const typeRoute = RETURN_TYPE_ROUTE_FOR_INDIVIDUAL_RECORD[return_.type];
  return `${returnsBaseUrl}/${typeRoute}/${return_._id}`;
}

/**
 * Deep link to a single return/claim/warranty/recycle record in the merchant
 * dashboard. Linking the dashboard root instead leaves the merchant to hunt for
 * the record.
 *
 * Withdrawals are out of scope: no merchant notification is sent for them, and
 * their record page keys on the CockroachDB `withdrawal.id`, not the return id
 * this builds from.
 */
export function merchantRecordUrl({
  baseUrl,
  storeId,
  returnId,
  returnType,
}: {
  /** Dashboard origin, from `merchantAppOrigin()`. */
  baseUrl: string;
  storeId: string;
  returnId: string;
  returnType: ReturnType;
}): string {
  const path = getReturnHref(`/stores/${storeId}/${RETURNS_AREA}`, {
    _id: returnId,
    type: returnType,
  });
  return new URL(path, baseUrl).toString();
}
